import React, { ChangeEvent } from "react";
import { Box, Switch, SvgIcon, Typography } from "@material-ui/core";
import AndroidIcon from "@material-ui/icons/Android";
import LinkIcon from "@material-ui/icons/Link";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import {
  AssistedAffiliationFieldName,
  AssistedAffiliationForm,
} from "../types";
import useAssistedAffiliationStyles from "../styles";

const TerminalCalculatorIcon = () => (
  <SvgIcon viewBox="0 0 24 24">
    <path d="M7 3h10c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm0 2v4h10V5H7zm1 7v2h2v-2H8zm4 0v2h2v-2h-2zm4 0v2h1v-2h-1zm-8 4v2h2v-2H8zm4 0v2h2v-2h-2zm4 0v2h1v-2h-1z" />
  </SvgIcon>
);

const affiliationOptions = [
  {
    field: "terminalBillet",
    title: "Terminal Billet",
    description: "Acepta pagos con terminal física (POS)",
    icon: <TerminalCalculatorIcon />,
  },
  {
    field: "billetap",
    title: "BilleTap",
    description: "Acepta pagos desde el celular",
    icon: <SmartphoneIcon />,
  },
  {
    field: "paymentLink",
    title: "Link de pagos",
    description: "Acepta pagos mediante enlace",
    icon: <LinkIcon />,
  },
  {
    field: "billetSmart",
    title: "Billet Smart",
    description: "Acepta pagos con terminal Android",
    icon: <AndroidIcon />,
  },
] as const;

type AffiliationToggleListProps = {
  form: AssistedAffiliationForm;
  onToggle: (field: AssistedAffiliationFieldName) => (
    event: ChangeEvent<HTMLInputElement>
  ) => void;
};

const AffiliationToggleList = ({ form, onToggle }: AffiliationToggleListProps) => {
  const classes = useAssistedAffiliationStyles();

  return (
    <Box className={classes.affiliationList}>
      {affiliationOptions.map(({ field, title, description, icon }) => (
        <Box className={classes.affiliationItem} key={field}>
          <Box className={classes.affiliationIcon}>{icon}</Box>
          <Box>
            <Typography className={classes.affiliationTitle}>{title}</Typography>
            <Typography className={classes.affiliationDescription}>
              {description}
            </Typography>
          </Box>
          <Switch
            checked={Boolean(form[field])}
            onChange={onToggle(field)}
            color="default"
            classes={{
              switchBase: classes.affiliationSwitchBase,
              checked: classes.affiliationSwitchChecked,
              track: classes.affiliationSwitchTrack,
              thumb: classes.affiliationSwitchThumb,
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default AffiliationToggleList;
